/****************************************************************************
 * Copyright (C) 2014-2016 ecsec GmbH.
 * All rights reserved.
 * Contact: ecsec GmbH (info@ecsec.de)
 *
 * This file is part of SkIDentity.
 *
 * This file may be used in accordance with the terms and conditions
 * contained in a signed written agreement between you and ecsec GmbH.
 *
 ***************************************************************************/

import { Logger } from "./Logger";

/**
 * @see https://github.com/ded/bowser/blob/master/src/useragents.js
 */
export class Browser {

	private static logger = new Logger("skidentity.util.Browser");

	static isOpera(): boolean {
		let is = ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1);
		this.logger.debug("isOpera: " + is);
		return is;
	}
	static isFirefox(): boolean {
		let is = (navigator.userAgent.indexOf("Firefox") != -1);
		this.logger.debug("isFirefox: " + is);
		return is;
	}
	static isSafari(): boolean {
		let is = (navigator.userAgent.indexOf("Safari") != -1 && !this.isEdge() && !this.isChrome());
		this.logger.debug("isSafari: " + is);
		return is;
	}
	static isIE11(): boolean {
		let is = (navigator.userAgent.indexOf("Windows NT 6") != -1 && navigator.userAgent.indexOf("rv:11.0") != -1);
		this.logger.debug("isIE11: " + is);
		return is;
	}
	static isEdge(): boolean {
		let is = (navigator.userAgent.indexOf("Edge") != -1);
		this.logger.debug("isEdge: " + is);
		return is;
	}
	static isChrome(): boolean {
		let is = (navigator.userAgent.indexOf("Chrome") != -1 && !this.isEdge());
		this.logger.debug("isChrome: " + is);
		return is;
	}

	static getBrowser(): string {
		return this.isChrome() ? "Chrome" :
			this.isEdge() ? "Edge" :
				this.isFirefox() ? "Firefox" :
					this.isIE11() ? "IE11" :
						this.isOpera() ? "Opera" :
							this.isSafari() ? "Safari" : "Unknown";
	}
}



// WEBPACK FOOTER //
// ./node_modules/@ecsec/base-libs/src/util/Browser.ts